import widgetsService from 'live/services/widgets'
import { widgetWrapper } from 'live/widgets/decorators/pure'
import reducer from './connectionFingerprintReducer'
import Chart from './ConnectionFingerprintChart'
import { Fields } from '../editor'
import i18n from 'live/services/i18n'
import thumbnail from '../../../assets/img/connection-fingerprint.png'

import ChannelSelector from '../editor/fields/ChannelSelector'
import ChannelLimit from '../editor/fields/ChannelLimit'
import NumericField from '../editor/fields/NumericField'
import React from 'react'
import AssetSelector from '../editor/fields/AssetSelector'
import { addNewEditor } from '../common/editorRegister'

const type = 'connection-fingerprint'

widgetsService.impl(
    type,
    widgetWrapper(Chart, reducer, {
        mapConfigToRender(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext.theme
            }
        },
        sampleTime: 500
    })
)
widgetsService.policies(type, {
    layers: 1,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: '@latest',
    handleOwnMissingData: true
})
widgetsService.queryHandlerKind(type, 'connectionfingerprint')
widgetsService.properties(type, {})
widgetsService.config(type, {
    verticalEnabled: false,
    volumeChannel: '',
    flowLimit: 0.01,
    flowStabilizationSlopeLimit: 0.001,
    volumeStabilizationSlopeLimit: 0.001,
    flowStabilizationWindow: 60,
    volumeStabilizationWindow: 60
})

const tabs = [
    <Fields name={'channels'}>
        <AssetSelector label={'Asset'} editorOnly={true} />
        <ChannelSelector configField="volumeChannel" label="Volume Channel" />
        <ChannelLimit configField="flowLimit" label="Flow Limit" />
        <ChannelLimit configField="flowStabilizationSlopeLimit" label="Flow Stabilization Slope Limit" />
        <ChannelLimit configField="volumeStabilizationSlopeLimit" label="Volume Stabilization Slope Limit" />
        <NumericField configField="flowStabilizationWindow" label="Flow Stabilization Window (seconds)" />
        <NumericField configField="volumeStabilizationWindow" label="Volume Stabilization (seconds)" />
    </Fields>
]

addNewEditor(
    {
        type,
        order: 11,
        label: i18n('Flowback Fingerprint'),
        description: i18n('Visualize flowback volume during connections'),
        tags: ['connection', 'fingerprint'],
        thumbnail: thumbnail
    },
    tabs
)
